module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-en2.6642da2.png";